import { formatBN } from "@hl/base-components/lib/utils/numbers";
import { LiveEvent } from "@hl/shared-features/lib/features/live/useLiveEvents";
import {
  buildTxUrl,
  networkLookup,
} from "@hl/shared-features/lib/utils/blockExplorer";

import {
  GetSalePageCollectionQuery,
  GetSalePageMintVectorsQuery,
} from "../queries.graphql.generated";

export type MintVector =
  GetSalePageMintVectorsQuery["getMintVectorsByCollection"][0];
export type Collection = GetSalePageCollectionQuery["getPublicCollection"];

export type Minter = {
  id: string;
  user: {
    address: string;
    ens: string;
    name: string;
  };
  amount: number;
  price: string;
  time: number;
  blockExplorerUrl: string;
};

const FILTER_BY_COLLECTION = true;

export const mapMinters = (
  events: LiveEvent[],
  currentMinters: Minter[],
  collectionId: string | null
) => {
  const currentMinterIds = new Set(currentMinters.map((minter) => minter.id));
  const uniqueMinters = new Set();
  const result: Minter[] = [];

  for (const event of events) {
    if (!filterMinter(event, collectionId)) continue;
    const mappedMinter = mapMinter(event);

    if (uniqueMinters.has(mappedMinter.id)) continue;
    uniqueMinters.add(mappedMinter.id);

    if (!currentMinterIds.has(mappedMinter.id)) {
      result.push(mappedMinter);
    }
  }

  return result;
};

const filterMinter = (item: LiveEvent, collectionId: string | null) => {
  if (item.mint == null) return false;
  if (!FILTER_BY_COLLECTION) return true;
  return item.collection.id.toLowerCase() === collectionId;
};

export const getCollectionId = (
  address: string,
  chainId: number,
  editionId?: string | null
) => {
  return `${chainId}:${address}:${editionId || 0}`;
};

const mapMinter = (item: LiveEvent): Minter => {
  {
    const network = networkLookup(item.chainId);
    const blockExplorerUrl = buildTxUrl(network.type, item.transactionHash);

    const price = item?.value ?? item.transactionValue;
    const priceFormatted = formatBN(price, 4);

    const userAddress = item.mint!.minter;
    const userDetails = item.users?.find(
      (u) => u.ownerAddress.toLowerCase() === userAddress
    );
    const userName = userDetails?.name || "";
    const userEns = userDetails?.ens || "";

    return {
      id: item.transactionHash,
      user: {
        address: userAddress,
        ens: userEns,
        name: userName,
      },
      price: priceFormatted,
      amount: item.mint!.tokenIds.length || 1,
      time: item.createdAt,
      blockExplorerUrl,
    };
  }
};
